// Reading the server's refusals around the trash (#1787). Pure, so the workspace can say what
// happened instead of showing a raw error.
import {
  ApiError,
  REQUEST_IN_TRASH,
  REQUEST_TRASH_CONFLICT,
  type RequestTrashRefusal,
} from "@/api";

const TRASH_REFUSALS: readonly RequestTrashRefusal[] = [
  "already_in_trash",
  "not_in_trash",
  "version_mismatch",
  "delivery_in_progress",
  "delivery_uncertain",
  "submission_pending",
  "filed",
  "email_qa_run",
  "purge_due",
  "message_deletion_pending",
];

/**
 * The refusal reason when the server declined a move to the trash or a restore, else null. Work on
 * a request that is already in the trash is reported as `already_in_trash` too: either way the
 * operator is looking at a request that is set aside.
 */
export function requestTrashRefusal(error: unknown): RequestTrashRefusal | null {
  if (!(error instanceof ApiError) || error.status !== 409) return null;
  const data = error.data as Record<string, unknown> | null;
  if (data?.code === REQUEST_IN_TRASH) return "already_in_trash";
  if (data?.code !== REQUEST_TRASH_CONFLICT) return null;
  const reason = data.reason;
  return TRASH_REFUSALS.find((known) => known === reason) ?? null;
}

/** The i18n key explaining a refusal to the operator. */
export function requestTrashRefusalKey(reason: RequestTrashRefusal): string {
  return `ws.trash.refused.${reason}`;
}
